import Index from "./Index.vue"
import StrangeGroup from "./StrangerGroup.vue"
import GroupDetail from "./GroupDetail.vue"
export default {
  routes: [
    {
      path: "/",
      component: Index
    },
    {
      path: "/stranger",
      component: StrangeGroup
    },
    {
      path: "/group-detail/:id",
      component: GroupDetail
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
}
